<template>
    <el-dialog title="物流信息填写" :visible.sync="showModal" :close-on-click-modal="false" :destroy-on-close="true" width="512px"
        append-to-body>
        <el-form :model="form" :rules="logisticRules" ref="form" label-width="80px">
            <el-form-item prop="logistics_name" label="物流公司">
                <!-- <el-input v-model="form.logistics_name" placeholder="物流公司" /> -->
                <el-select v-model="form.logistics_name" placeholder="请选择物流公司" @change="getClassify">
                    <el-option :label="item.name" :value="item.name" v-for="item, index in logisticsList" :key="index" />
                </el-select>
            </el-form-item>
            <el-form-item prop="logistics_number" label="物流单号">
                <el-input v-model="form.logistics_number" placeholder="请输入内容"  />
            </el-form-item>
            <div>
                <el-button @click="trunOff">取消</el-button>
                <el-button type="primary" @click="onSend('form')" :loading="submitingLogistic">确定</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>

<script>
import { orderList } from "@/api/creditShop"

export default {
    data: () => ({
        logisticRules: {
            logistics_name: [{ required: true, message: '请输入物流公司', trigger: 'blur' }],
            logistics_number: [{ required: true, message: '请输入物流编号', trigger: 'blur' }],
        },
        form: {
            order_id: null,
            logistics_name: "",
            logistics_number: ""
        },
        submitingLogistic: false,
        logisticsList: [
            {
                name: '日本郵便',
                id: 1,
            },
            {
                name: 'ヤマト運輸',
                id: 2,
            },
            {
                name: '佐川急便',
                id: 3,
            },
            {
                name: '其他',
                id: 4,
            },
        ]
    }),
    props: {
        // 展示
        show: {
            default: false,
            type: Boolean
        },
        // 订单编号
        order_id: String
    },
    methods: {
        trunOff() {
            this.showModal = false
        },
        onSend(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (valid) {
                    this.submitingLogistic = true

                    try {
                        await orderList.shipping(this.form)
                        this.$message({
                            message: `${this.createModalTitle}项目成功!`,
                            type: 'success'
                        });
                        this.$emit("onUpdate")
                        this.showModal = false
                    } catch {
                        this.$message.error('出错了!');
                    } finally {
                        this.submitingLogistic = false
                    }
                }
            });
        }
    },
    computed: {
        showModal: {
            get() {
                return this.show;
            },
            set(val) {
                this.$emit('update:show', val);
            }
        }
    },
    created() {
        this.form.order_id = this.order_id
    }
}
</script>

<style lang="scss" scoped></style>